module.exports = __webpack_public_path__ + "static/edgard-periera-d621223a2ed70bed85aaf4864700cb5e.jpg";